﻿export function initReferentTable() {
  app.initSlimSelects();
  app.initAjaxTables();
}